import React from 'react';
import SubmittedReviewFileUploads from './SubmittedReviewFileUploads';
import ReviewTypeQuestionResults from './ReviewTypeQuestionResults';
import './ReviewSummary.styl';
import Button from '@material-ui/core/Button';
import InProgressReview from 'records/InProgressReview';
import InProgressReviewActions from 'actions/coaching/InProgressReviewActions';
import * as queryParams from 'utils/queryParams';
import {associateBy} from 'utils/associateBy';
import CoachingReviewInfoBar from 'components/coaching/CoachingReviewInfoBar';
import {RichText} from 'components/pure/utils/form/user-taggable-input/RichTextEditor';
import ReviewTypeSelect from 'components/coaching/ReviewTypeSelect';
import ReviewTypeQuestions from 'components/coaching/ReviewTypeQuestions';
import {Map} from 'immutable';
import hasFlag from 'utils/hasFlag';
import {featureFlags} from 'utils/const';
import GoalsKpiEditableList from 'components/coaching/goals-kpi-editable-list';
import {isNonEmptyAnswer} from 'components/coaching/IsNonEmptyAnswer';

export default class ReviewSummary extends React.PureComponent {
  state = {reviewTypeId: null};

  componentDidMount() {
    const {review} = this.props;
    this.setState({
      reviewTypeId: review.reviewTypeId,
    });
  }

  allAnswersAreEmpty(answers) {
    // XXX EV-14872 should not be getting null
    if (!answers) return true;
    return !answers.some(answer => isNonEmptyAnswer(answer));
  }

  setInProgressReview() {
    const {review, plan, reviewFileUploads, sessionUser} = this.props;

    const inProgressReview = new InProgressReview({
      id: review.id,
      scheduleAt: review.scheduleAt,
      planId: review.planId,
      recipientId: plan.recipient.id,
      reviewFileUploads: reviewFileUploads,
      comment: review.comment,
      reviewTypeAnswers: associateBy(review.reviewTypeAnswers, r => r.reviewQuestionId),
      coachingReviewTypeId: review.reviewTypeId,
      adHoc: plan.adHoc,
    });

    InProgressReviewActions.setInProgressReview(inProgressReview, sessionUser);
    queryParams.set({reviewId: review.id, editFeedback: true}, true);
  }

  render() {
    const {
      review,
      contentDetailId,
      reviewFileUploads,
      highLevelScores,
      calls,
      users,
      coachingReviewTypes,
      sessionUser,
      plan,
      toggleModify,
      isCoach,
      isRecipient,
    } = this.props;
    const {reviewTypeId} = this.state;

    if (!review) {
      return (
        <div className={'placeholder'}>
          <p>No completed reviews.</p>
        </div>
      );
    }

    const reviewType = coachingReviewTypes && coachingReviewTypes.get(reviewTypeId);

    // allow reps to select review types and preview questions
    // before the review is complete
    const reviewComplete = review.status === 'COMPLETED';

    const loadingIsSettled = !!reviewFileUploads;

    return (
      <section className="review-summary">
        <CoachingReviewInfoBar
          plan={plan}
          review={review}
          users={users}
          sessionUser={sessionUser}
          inProgress={false}
          toggleModify={toggleModify}
          isRecipient={isRecipient}
        />
        <ReviewTypeSelect
          coachingReviewTypes={coachingReviewTypes.toList()}
          reviewTypeId={reviewTypeId}
          onChange={id => this.setState({reviewTypeId: id})}
          reviewComplete={reviewComplete}
        />
        {reviewType && reviewType.includesCalls && (
          <div>
            <h4>Reviewed Calls</h4>
            {loadingIsSettled && (
              <SubmittedReviewFileUploads
                selectedContentDetailId={contentDetailId}
                reviewFileUploads={reviewFileUploads}
                highLevelScores={highLevelScores}
                users={users}
                calls={calls}
                isLivecoachingPlan={plan.livecoaching}
                planId={plan.id}
                coachId={review.coachUserId}
                isRecipient={isRecipient}
                scorecardId={plan.scorecardId}
                reviewId={review.id}
              />
            )}
          </div>
        )}
        {reviewType && !reviewComplete && (
          <ReviewTypeQuestions
            onChange={() => null}
            answers={Map()}
            errors={Map()}
            reviewType={reviewType}
            reviewFileUploads={reviewFileUploads}
            disabled={true}
            isCoach={isCoach}
            isRecipient={isRecipient}
          />
        )}
        {reviewType && !this.allAnswersAreEmpty(review.reviewTypeAnswers) && (
          <div>
            <h4>
              {reviewType.questions.size > 0 &&
                (!reviewFileUploads || reviewFileUploads.size === 0
                  ? 'Questions for Review'
                  : 'Additional Review')}
            </h4>
            <ReviewTypeQuestionResults answers={review.reviewTypeAnswers} reviewType={reviewType} />
          </div>
        )}
        {hasFlag(featureFlags.adminKpis) && hasFlag(featureFlags.coachingChartForGoals) && (
          <div className="kpi-list">
            <GoalsKpiEditableList
              plan={plan}
              inProgress={false}
              repId={plan.recipient.id}
              editedKpis={this.props.editedKpis}
              setEditedKpis={this.props.setEditedKpis}
              reviewCompletedAt={review.completedAt}
            />
          </div>
        )}
        {review.comment && (
          <div>
            <h4>General Comments</h4>
            <div className="general-comments-wrapper">
              <section>
                <RichText className="general-comments" dangerousText={review.comment} />
              </section>
            </div>
          </div>
        )}
        {sessionUser.id === review.coachUserId && !plan.completed && (
          <div className="edit-review">
            <Button
              variant="outlined"
              className="ev-button"
              onClick={() => this.setInProgressReview()}>
              Edit Meeting
            </Button>
          </div>
        )}
      </section>
    );
  }
}
